module.exports = __webpack_public_path__ + "static/tabs-switch-do-ba5810d383c89f54f36b00d193b090cb.png";